import React from 'react';
import { Music, Video, Headphones, Zap, Feather } from 'lucide-react';

const MEDIA = [
  { key: 'has_video', name: 'video', icon: Video, label: 'Video instructions' },
  { key: 'has_audio', name: 'audio', icon: Headphones, label: 'Audio instructions' },
  { key: 'has_music', name: 'music', icon: Music, label: 'Music' },
];

export const MediaBadges = ({ tech, className = '' }) => {
  const present = MEDIA.filter((m) => tech && tech[m.key]);
  if (!present.length) return null;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={`media-badges-${tech.slug}`}>
      {present.map(({ key, name, icon: Icon, label }) => (
        <span key={key} title={label} aria-label={label} data-testid={`media-${name}-${tech.slug}`}
          className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-burgundy/10 text-burgundy">
          <Icon className="w-3.5 h-3.5" />
        </span>
      ))}
    </div>
  );
};

export const CategoryBadge = ({ tech, className = '' }) => {
  const cat = ((tech && (tech.category || (tech.categories && tech.categories[0]))) || '').trim().toLowerCase();
  if (cat !== 'active' && cat !== 'passive') return null;
  const isActive = cat === 'active';
  const Icon = isActive ? Zap : Feather;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${isActive ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'} ${className}`}
      data-testid={`category-badge-${tech.slug}`}>
      <Icon className="w-3 h-3" /> {isActive ? 'Active' : 'Passive'}
    </span>
  );
};
